import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

function Image() {

    return (

        <>
            <>
                <Header />

                {/* Page Header Section Start */}
                <div className="page-header bg-section parallaxie">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* Page Header Box Start */}
                                <div className="page-header-box">
                                    <h1 className="text-anime-style-3" data-cursor="-opaque">
                                        Our gallery
                                    </h1>
                                 
                                </div>
                                {/* Page Header Box End */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Page Header Section End */}
                {/* Photo Gallery Start */}
                <div className="page-gallery">
                    <div className="container">
                        {/* gallery section start */}
                        <div className="row gallery-items page-gallery-box">
                            <div className="col-lg-4 col-6">
                                {/* Image Gallery start */}
                                <div className="photo-gallery wow fadeInUp">
                                    <Link to="images/media-1.jpeg" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="images/media-1.jpeg" alt="" />
                                        </figure>
                                    </Link>
                                </div>
                                {/* Image Gallery end */}
                            </div>
                            <div className="col-lg-4 col-6">
                                {/* Image Gallery start */}
                                <div className="photo-gallery wow fadeInUp" data-wow-delay="0.2s">
                                    <Link href="images/media-2.jpeg" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="images/media-2.jpeg" alt="" />
                                        </figure>
                                    </Link>
                                </div>
                                {/* Image Gallery end */}
                            </div>
                            <div className="col-lg-4 col-6">
                                {/* Image Gallery start */}
                                <div className="photo-gallery wow fadeInUp" data-wow-delay="0.4s">
                                    <Link to="images/media-3.jpeg" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="images/media-3.jpeg" alt="" />
                                        </figure>
                                    </Link>
                                </div>
                                {/* Image Gallery end */}
                            </div>
                         
                        </div>
                        {/* gallery section end */}
                    </div>
                </div>
                {/* Photo Gallery End */}

                <Footer />
            </>

        </>
    );
}

export default Image;